import { Reducer } from 'redux';
import { IOpenMenuState, IOpenMenuAction } from './types';

const initialState = {
  openMenu: false
}

const OpenMenuReducer: Reducer<IOpenMenuState> = ((state:IOpenMenuState = initialState, action) => {
  switch((action as IOpenMenuAction).type) {
    case "OPEN_MENU": {
      return { ...state, openMenu: action.payload}
    }
    default:
      return state
  }
});

export default OpenMenuReducer;
